// Dependencies
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
// Components, actions, assets..
import CloseModalButton from '../CloseModalButton';
import { addOrganization } from '../../../actions/organization/organizationActions';
import EditOrganizationForm from '../../forms/organizations/EditOrganizationForm';

function AddOrganizationModal(props) {
  const { t } = useTranslation();
  const submitButton = () => (
    <button
      type="submit"
      className="btn btn-primary ml-auto"
    >
      {t('components.modals.organizations.addOrganizationModal.submit')}
    </button>
  );

  const { content, closeModal } = props;

  return (
    <>
      <div className="modal-header border-0 align-items-start">
        <div className="w-100 h-50 d-flex flex-column align-items-center">
          <img src={content.icon} className="img-fluid mb-2" alt="Logo" height="50" width="50" />
          <h1 className="header-title text-center">{t('components.modals.organizations.addOrganizationModal.add')}</h1>
        </div>
        <CloseModalButton closeModal={closeModal} />
      </div>
      <div className="modal-body d-flex flex-column p-3 container-fluid">
        <div className="col pt-3">
          <h4 className="text-center">{t('components.modals.organizations.addOrganizationModal.theseAre')}</h4>
        </div>
        <EditOrganizationForm onSubmitAction={addOrganization} submitButton={submitButton()} />
      </div>
    </>
  );
}

AddOrganizationModal.propTypes = {
  content: PropTypes.shape({
    id: PropTypes.string,
    icon: PropTypes.string,
  }).isRequired,
  closeModal: PropTypes.func.isRequired,
};

export default AddOrganizationModal;
